<template>
  <b-overlay 
    :show="servicebusy" 
    variant="dark"
  >  
    <b-input-group 
      class="my-3 w-50" 
      prepend="Filter jaar"
    >
      <b-select 
        v-model="jaar" 
        :options="[...jaren]"
      />
    </b-input-group>
    <b-table 
      :fields="[ {key:'message'},'note',{key: 'reported',thStyle: colStyle},{key: 'confirmed',thStyle: colStyle},{key: 'started',thStyle: colStyle},{key: 'stopped',thStyle: colStyle},{key:'runtime_type',thStyle: colStyle},]" 
      :items="ticketsSorted" 
     
      striped 
      small 
      bordered
    >
      <template #cell(reported)="row">
        {{ moment(row.item.reported).format('lll') }}
      </template>
      <template #cell(confirmed)="row">
        {{ row.item.confirmed ? moment(row.item.confirmed).format('lll') : '-' }}
      </template>
      <template #cell(started)="row">
        {{ row.item.started ? moment(row.item.started).format('lll') : '-' }}
      </template>
      <template #cell(stopped)="row">
        {{ row.item.stopped ? moment(row.item.stopped).format('lll') : '-' }}
      </template>
    </b-table>
  </b-overlay>
</template>
<script>
  import { unitTabMixin } from '@/mixins/unitMixin'
  import { serviceMixin } from '@/mixins/serviceMixin'
  import moment from "moment";
  export default {
    name: 'Service',
    components: {},
    mixins: [ unitTabMixin, serviceMixin ],
    props: {
    },
    data () {
      return {
        colStyle: {
          'width': '150px'
        },
        tickets: [],
        jaar: new Date().getFullYear(),
      }
    },
    computed: {
      ticketsSorted: function() { return [...this.tickets].filter(i => moment((i.reported || i.confirmed)).toDate().getFullYear()  ==  this.jaar); },
      jaren: function() { return [...new Set(this.tickets.filter(d => d.reported != null).map(t => moment(t.reported).toDate().getFullYear()))]; },
    },
    watch: {
      unit: {
        handler: function () {
          this.getTickets();
        },
        deep: true,
      },
    },
    mounted () {
        this.getTickets();
    },
    methods: {
        getTickets() {
            this.get(this.unitServicePath)
            .then((response) => {
                console.log(response.data.tickets);
                this.tickets = response.data.tickets
            }).catch((error) => {
                console.log(error)
            });
        }
    }
  
  }
</script>